import { atom } from 'jotai/vanilla';
import type { ClientSelectedItemCollection } from '@model-framework/client-selected-item/domain';
import type { ModelId } from 'balus-common';
import { atomFamily } from 'jotai/vanilla/utils';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const clientSelectedItemCollectionAtomFamily = atomFamily((_modelId: ModelId) => {
  return atom<ClientSelectedItemCollection | null>(null);
});
